import React, { useState } from 'react';
import { View } from 'react-native';
import { isPhone } from '@helpers';
import { WALLBOARD_TOUR_IDS } from '@components/tours/config/wallboard/constants';
import DatePicker from './DatePicker';
import WallboardLevel from './WallboardLevel';
import MachinesGroupPopupBtn from './MachinesGroupPopupBtn';
import MachinesGroupPopup from './MachinesGroupPopup';

export default (props) => {
  const {
    C,
    machines,
    setFilterMachinesByGroup,
    wallboardSelectedLevel,
    wallboardTimelineEndDate,
    setWallboardTimelineEndDate,
    setWallboardSelectedLevel,
    sendLog,
    getMachinesGroup,
    machinesGroupLoaded,
    machinesGroup = [],
    localTime,
    isSameDay,
    Selector,
    Svg,
    TouchableElement,
    Arrow,
    width,
    Loading,
    AnimatedTable,
    formatSinceDate,
    isWeb,
    filterMachinesByGroup,
    font,
    Button,
    navigateTo,
    navigateTitle,
  } = props;

  const [isPopupActive, setIsPopupActive] = useState(false);

  return [
    <View
      key="wallboardHeader"
      style={{
        backgroundColor: C('Background/Dark/System'),
        position: 'absolute',
        width: '100%',
        height: 43,
        top: 0,
      }}
    >
      <View
        style={{
          width: '100%',
          height: 43,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: C('Background/Light/Chart'),
        }}
      >
        <View
          style={{
            width: width,
            height: 43,
            justifyContent: isPhone ? 'space-between' : 'center',
            flexDirection: 'row',
            alignItems: 'center',
            paddingHorizontal: 18,
          }}
        >
          {isPhone && (
            <View style={{ width: 208, height: 27 }}>
              {(wallboardSelectedLevel === 'last24' || wallboardSelectedLevel === 'today') && (
                <DatePicker
                  {...{
                    C,
                    wallboardSelectedLevel,
                    wallboardTimelineEndDate,
                    setWallboardTimelineEndDate,
                    localTime,
                    formatSinceDate,
                    isSameDay,
                    Arrow,
                    isWeb,
                  }}
                />
              )}
            </View>
          )}
          <WallboardLevel {...{ wallboardSelectedLevel, setWallboardSelectedLevel, sendLog, Selector, navigateTitle, tourId: WALLBOARD_TOUR_IDS.LEVEL_SELECTOR }} />
          {isPhone ? (
            <MachinesGroupPopupBtn
              {...{
                C,
                customStyle: { backgroundColor: C('Button/Light/Secondary') },
                setIsPopupActive,
                Svg,
                TouchableElement,
                isWeb,
                name: machinesGroup.find((m) => m.machineGroupId == filterMachinesByGroup)?.name,
                tourId: WALLBOARD_TOUR_IDS.MACHINE_FILTER,
              }}
            />
          ) : null}
        </View>
        {!isPhone && (wallboardSelectedLevel === 'last24' || wallboardSelectedLevel === 'today') && (
          <View style={{ position: 'absolute', left: 18, height: 43, justifyContent: 'center' }}>
            <DatePicker
              {...{
                C,
                wallboardSelectedLevel,
                wallboardTimelineEndDate,
                setWallboardTimelineEndDate,
                localTime,
                formatSinceDate,
                isSameDay,
                Arrow,
                isWeb,
              }}
            />
          </View>
        )}
        {!isPhone && !isPopupActive && (
          <View style={{ position: 'absolute', right: 18, height: 43, justifyContent: 'center' }}>
            <MachinesGroupPopupBtn
              {...{
                C,
                customStyle: { backgroundColor: C('Button/Light/Secondary') },
                setIsPopupActive,
                Svg,
                TouchableElement,
                isWeb,
                name: machinesGroup.find((m) => m.machineGroupId == filterMachinesByGroup)?.name,
                tourId: WALLBOARD_TOUR_IDS.MACHINE_FILTER,
              }}
            />
          </View>
        )}
      </View>
    </View>,
    isPopupActive && (
      <MachinesGroupPopup
        {...{
          C,
          machines,
          setIsPopupActive,
          setFilterMachinesByGroup,
          getMachinesGroup,
          machinesGroupLoaded,
          machinesGroup,
          Svg,
          TouchableElement,
          width,
          Loading,
          AnimatedTable,
          isWeb,
          filterMachinesByGroup,
          font,
          Button,
          navigateTo,
        }}
      />
    ),
  ];
};
